import React, {useState/*,useRef,useContext*/}  from 'react'
import {localestr/*,isNumeric,load,dataContext*/} from '../utils'
import icon from '../icons.svg'; 
import Switch from './Switch'
import Calc from './Calc'

function DeliveryForm({need_delivery,couriers,action,setModal,setModal2}){
    const [dlv, setDlv] = useState(need_delivery) 
    const [sum1, setSum1] = useState(60) 
    const [sum2, setSum2] = useState(100) 
    const [cur, setCur] = useState('') 
    //const context=useContext(dataContext)

    const closeWnd=()=>{
        const d={courier:cur,reward:parseFloat(sum2)}
        if(dlv&&need_delivery) d.delivery=parseFloat(sum1)
        action(d)
        setModal('')
    }

    const calcSum1=()=>{
        const modal2=<Calc value={sum1} caption={localestr('Сума')} setValue={setSum1} setModal={setModal2}/>
        setModal2(modal2)
    }
    const calcSum2=()=>{
        const modal2=<Calc value={sum2} caption={localestr('Сума')} setValue={setSum2} setModal={setModal2}/>
        setModal2(modal2)
    }

    //console.log(pay)

    //Чи додавати послугу доставки Вартість послуги доставки
    let cont2=<div style={{margin:'8px 0',display:'flex',justifyContent:'center',alignItems:'center'}}>
        <Switch value={dlv?1:0} chngValue={d=>{setDlv(!d)}}/>
        <div style={{fontSize:'large',flexGrow:'10',padding:'5px',marginLeft:'5px'}}><label htmlFor='sum1'>{localestr('Додати доставку')}</label></div>
        <input onChange={e=>{setSum1(e.target.value)}} value={sum1||''} id='sum1' type="number"
            style={{width:'60px',boxSizing:'border-box',textAlign:'right',height:'38px',fontSize:'larger',fontWeight:'bold',border:'solid 1px #0006',borderRadius:'6px',background:'#0000'}}/>
        <div className='toolBarImg2' style={{margin:'0',maskImage:'url('+icon+'#btn3)',WebkitMaskImage:'url('+icon+'#btn3)',cursor:'pointer'}} onClick={calcSum1}></div>
    </div>
    if(!need_delivery) cont2=null
    let cont3=null //Винагорода курєру
    cont3=<div style={{margin:'8px 0',display:'flex',justifyContent:'center',alignItems:'center'}}>
        <div style={{fontSize:'large',flexGrow:'10',padding: '5px'}}><label htmlFor='sum2'>{localestr('Винагорода кур\'єру')}</label></div>
        <input onChange={e=>{setSum2(e.target.value)}} value={sum2||''} id='sum2' type="number"
            style={{width:'60px',boxSizing:'border-box',textAlign:'right',height:'38px',fontSize:'larger',fontWeight:'bold',border:'solid 1px #0006',borderRadius:'6px',background:'#0000'}}/>
        <div className='toolBarImg2' style={{margin:'0',maskImage:'url('+icon+'#btn3)',WebkitMaskImage:'url('+icon+'#btn3)',cursor:'pointer'}} onClick={calcSum2}></div>
    </div>
    let cont4=null //Вибір курєра
    cont4=<div style={{margin:'8px 0',display:'flex',justifyContent:'center',alignItems:'center'}}>
        <div style={{fontSize:'large',flexGrow:'10',padding: '5px'}}><label htmlFor='cur'>{localestr('Кур\'єр')}</label></div>
        <select value={cur} onChange={(e)=>{setCur(e.target.value)}} id='cur'
            style={{width:'230px',height:'38px',margin:'1px',fontSize:'larger',fontWeight:'bold',padding: '5px',border:'solid 1px #0006',borderRadius:'6px',background:'#0000'}}>
            <option value={''}>{localestr('Вільний кур\'єр')}</option>
            {couriers.map(el=>{return(<option key={el.id}  value={el.id}>{el.name}</option>)})}
        </select>
    </div>


    
    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function dragMouseDown(e) {
      e = e || window.event;
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }
    
    function elementDrag(e) {
      const elmnt=document.getElementById('modalWndPay')
      e = e || window.event;
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
  
    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }

    return(
        <div className='modal'><div id={'modalWndPay'} className='window' style={{width:'325px'}}>
            <div onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{localestr('Доставка')}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content' style={{outline:'none'}}>
                <div style={{display:'flex',flexDirection:'column',height:'calc(100% - 38px)'}}>
                    <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                        <div className='toolBarImg2' style={{margin:'-10px 0',width:'76px',height:'76px',maskImage:'url('+icon+'#btn24)',WebkitMaskImage:'url('+icon+'#btn24)'}}></div>
                        <div style={{fontSize:'large',fontWeight:'bold',flexGrow:'10',padding:'5px',marginLeft:'16px'}}>{localestr('Передати замовлення у доставку')}</div>
                    </div>
                    <div style={{marginBottom:'16px',display:'flex',justifyContent:'center',alignItems:'center'}}>
                        <div style={{fontSize:'normal',flexGrow:'10',padding:'1px',marginLeft:'1px',color:'#00F'}}>{localestr('Увага! Після передачі у доставку замовлення не можна редагувати!')}</div>
                    </div>
                    {cont2}
                    {cont3}
                    {cont4}
        <div style={{margin:'8px 0 0 0',display:'flex',justifyContent:'center'}}>
        <div style={{width:'80px',height:'32px',display:'inline-block',verticalAlign:'bottom'}} className={'ord_button2 toolBarItem toolBarItem2'} onClick={closeWnd}><div style={{height:'30px',lineHeight:'24px',display:'block'}}>OK</div></div>
        <div style={{width:'80px',display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Закрити')}</div></div>
        </div>
                </div>
            </div>
        </div></div>
    )
}

export default DeliveryForm